<template>
  <div class="no-select home">
      <v-wait for="project-load">
        <template slot="waiting">
          <div class="vh-100 dt w-100 aspect-ratio--object grey">
            <div class="dtc v-mid tc white ph3 ph4-l">
              <!-- <h1 class="f6 f2-m f-subheadline-l tc green">loading</h1> -->
            </div>
          </div>
        </template>
        <div class="work">
          <div  class="work-container w-70 h-29 h-39-ns" v-for="(project, index) in homepageImages"
                :class="{ 'w-26-ns': project.horizontal == false && project.square == false,
                          'w-45-ns': project.horizontal == true && project.square == false,
                          'w-40-ns': project.horizontal == false && project.square == true,
                        }"
                :style="{ transform: calculateImagePlacement(project.horizontal) }">
            <a href="https://docs.google.com/presentation/d/1SumRT1_5vEy8XZK0kn7XPdAXCkZCPvXTV4IDdRAUOJQ/edit?usp=sharing" target="_blank" alt="">
              <ImageItem  class="prj"
                          v-if="project.img_url"
                          :source="project.img_url"
                          :name="project.hover_text"
                          />
            </a>
          </div>
        </div>
        <!-- <div id="scroll-ux" class="fixed bottom-0 w-100 pv3 tc f4 green helvetica-ext o-1" v-if="mobile">scroll down</div> -->
      </v-wait>
  </div>
</template>

<script>
import { tippy } from "vue-tippy";
import {_} from 'vue-underscore';
import { isMobile, deviceType } from 'mobile-device-detect';
import ImageItem from "@/components/ImageItem";

export default {
  name: 'home',
  components: {
    ImageItem
  },
  data() {
    return {
      currentProject: {},
      allProjects: [],
      homepageImages: [],
      targetTitle: '',
      mobile: false,
      scrollTop: true,
      MAX_HOMEPAGE_IMAGES: 40
    }
  },
  methods: {
    goToProject(projectId) {
      this.$router.push({ name: 'project', params: { project_id: projectId } });
    },
    getImgUrl(img) {
      var images = require.context('../assets/', false, /\.(gif|jpe?g|tiff?|png|webp|bmp)$/);
      return images('./' + img)
    },
    getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    calculateImagePlacement(horizontal) {
      var transform;

      if (!isMobile) {
        if (!horizontal) {
          transform = 'translate3d('+ this.getRandomInt(36, 58) + 'vw, -'+ this.getRandomInt(45, 65) + '%, 0px)';
        }
        else {
          transform = 'translate3d('+ this.getRandomInt(22, 34.8) + 'vw, -'+ this.getRandomInt(45, 65) + '%, 0px)';
        }
      }
      else {
        if (deviceType != 'tablet') {
          transform = 'translate3d('+ this.getRandomInt(1, 14) + 'vw, -'+ this.getRandomInt(47, 77) + '%, 0px)';
        }
        else {
          transform = 'translate3d('+ this.getRandomInt(14, 30) + 'vw, -'+ this.getRandomInt(47, 77) + '%, 0px)';
        }

      }

      return transform;
    },
    sanitizeHomepageImages() {
      for (var img in this.homepageImages) {
        if (typeof this.homepageImages[img].img_url == 'undefined') {
          this.homepageImages.splice(img, 1);
        }
      }
    },
    pruneHomepageImages() {
      if (this.homepageImages.length > this.MAX_HOMEPAGE_IMAGES) {
        var pruned = this.homepageImages.slice(0, this.MAX_HOMEPAGE_IMAGES);
        this.homepageImages = pruned;
      }
    }
  },
  created() {
    var that = this;

    // console.log(isMobile);

    this.$wait.start('project-load');

    if (isMobile) {
      that.mobile = true;
      // document.getElementById("scroll-ux").style.opacity = "1";
    }

    this.$store.dispatch('fetchHomepage', { vm: this, cb:
      function(results) {
        that.allProjects = results;

        that.$store.dispatch('fetchHomepageImages', { vm: that, cb:
          function(results) {
            // console.log(results);
            that.homepageImages = results;

            that.sanitizeHomepageImages();

            that.homepageImages = _.shuffle(that.homepageImages);

            that.pruneHomepageImages();

            that.$wait.end('project-load');

            that.$store.dispatch('fetchInfoPage', { vm: that, cb: function(results) {
              // just store the info and do nothing
              return true;
            }});

            // if (isMobile) {
            //   document.getElementById("scroll-ux").style.opacity = "1";
            // }
          }
        });
      }
    });

    window.onresize = function(e) {

    };

    window.onscroll = function(e) {

    };
  },
  mounted() {

  },
  destroyed() {

  }
}
</script>

<style scoped>
  .disable-hover {
    pointer-events: none;
  }

  img {
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    /*cursor: pointer;*/
  }

  .work {
    display: grid;
    padding-top: 50vh;
    z-index: 2;
    position: relative;
    /*margin-bottom: 10vh;*/
  }

  .work .work-container {
    /*height: 40vh;
    width: 30%;*/

    /*height: 39vh;
    width: 26%;*/



    object-fit: contain;
    position: -webkit-sticky; /* Safari */
    position: sticky;
    /*top: 50vh;
    margin-bottom: 10vh;*/

    top: 30vh;
    margin-bottom: 30vh;

    /*top: 50vh;
    margin-bottom: 32vh;*/
  }

  .work-container img {
    object-fit: contain;
    position: -webkit-sticky; /* Safari */
    position: sticky;
    max-width: 100%;
  }

  .prj {
    /*display: block;
    margin: 15px;
    width: 35px;
    height:35px;
    border-radius: 50%;
    background-color: orange;*/
  }

  .specificLocation {
    margin-left: 100px;
  }

  .fit {
    -o-object-fit: contain;
    object-fit: contain;
  }

  #photo_landscape { display: block; }
  #photo_vertical { display: none; }

  .no-select {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  #observer-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 150vh;
    z-index: 1;
    background-color: purple;
  }

  @media screen and (max-width: 480px) {
    .work {
      padding-top: 60vh;
    }

    .work .work-container {
      /*margin-bottom: 20vh;*/
      margin-bottom: 11vh;
      top: 60vh;
    }

    .h-29 {
      height: 29vh;
    }
  }

  @media screen and (min-width : 481px) and (max-width: 768px) {
    #photo_landscape { display: none; }
    #photo_vertical { display: block; }

    .w-26-ns, .w-45-ns {
      width: 50% !important;
    }

    .h-39-ns {
      height: 39vh;
    }
  }

  @media screen and (min-width: 30em) {
    .w-26-ns {
      /*width: 26%;*/
      width: 30%;
    }

    .w-45-ns {
      /*width: 26%;*/
      width: 65%;
    }

    .h-39-ns {
      height: 39vh;
    }

  }
</style>
